import React, { Component } from "react"
import { NavLink } from "react-router-dom"
export default class AchiModal extends Component {
  render() {
    let modelStyle = {
      display: "block",
      backgroundColor: "rgba(0,0,0,0.8)",
    }
    const name = this.props.achidata
    return (
      <div className="modal show fade" style={modelStyle}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title head tran_color">Achievements</h1>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={this.props.hide}
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
            <div className="m-4">
              <ol>
                {name.map((name) => (
                  <li className="f_color" style={{ fontSize: "1.3rem" }}>
                    {name}
                  </li>
                ))}
              </ol>
            </div>
            <div className="modal-footer">
              <NavLink to="" className="btn-get-started main-color">
                View Documents 📈
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
